import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d99d228"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category text-white position-absolute d-flex justify-content-end align-items-center fw-bold fs-75" }

import { translate } from '@/languages/i18n'
import { computed, ComputedRef } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  content_type: {
    type: Number,
  },
},
  setup(__props) {

const props = __props



const renderTitle: ComputedRef<string> = computed(() => {
  const titleObj = {
    '1': translate('article'),
    '2': translate('recruitment'),
    '3': translate('jobOffer'),
    '5': translate('article'),
  }

  return titleObj[props.content_type]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(renderTitle)), 1))
}
}

})